export const formatedPercent = (number) => {
  if (!isFinite(number) || isNaN(number)) {
    return '0.00%'
  }
  console.log(number)
  return new Intl.NumberFormat('default', {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number / 100)
}
